export const getIconContext = () =>
  // @ts-ignore
  (import.meta as any).webpackContext('../../../../assets/icon', {
    recursive: true,
    regExp: /^\.\/.*\.svg$/,
  });
